import styled from "styled-components";
import Category from "../components/Category";
import { lazy, useEffect, useRef, useState } from "react";
import { Layout, LayoutContent, Separator } from "../globalStyles/CommonStyles";
import { useRecoilState, useRecoilValue } from "recoil";
import { scrollMenu } from "../recoil/Atoms";
import { analytics } from "../firebase.config";
import { Switch, Route, useLocation } from "react-router-dom";
import { AnimatePresence, AnimateSharedLayout, useTransform, useViewportScroll } from "framer-motion";
import { cartStatus, categoriesFetched, infoFetched } from "../recoil/Selectors";
import { duplicate, getLastOrder, isClosed, lastOrderActive } from "../utils/functions";
import { DateTime } from "luxon";
import { logEvent } from "firebase/analytics";
import { categoryType, clientType } from "../utils/types";
import * as Variables from "../globalStyles/Variables";
import useWindowSize from "../utils/useWindowSize";
import PopUp from "../components/PopUp";
import Interested from "../components/sections/Interested";
import Footer from "../components/sections/Footer";
import Benefits from "../components/sections/Benefits";

//components 
const Hours = lazy(() => import("./Hours"));
const Zones = lazy(() => import('./Zones'));
const Contact = lazy(() => import("./Contact"));
const GoBag = lazy(() => import("../components/buttons/GoBag"));
const Message = lazy(() => import("../components/buttons/Message"));
const Recommended = lazy(() => import('../components/sections/Recommended'));
const Details = lazy(() => import("../components/sections/Details"));
const Checkout = lazy(() => import('../components/sections/Checkout'));

const CurrentOrder = lazy(() => import("../components/sections/CurrentOrder"));
const Header = lazy(() => import("../components/sections/Header"));
const Bag = lazy(() => import("../components/sections/Bag"));


const MainContainer = styled.div`
  display:grid;
  gap:24px;
`;

const HeaderContainer = styled.div`
  display:grid;
  gap:24px;

  @media ${Variables.device.tablet}{
    gap:32px;
    height: fit-content;
  }
`
const ContentContainer = styled.div`
  display:grid;
  gap:16px;
`


const WeAreClosed = () => {
  const lastOrder = getLastOrder()

  if (lastOrder) {
    const date_estimated = DateTime.fromJSDate(new Date(lastOrder.date_estimated))
    const orderActive = DateTime.fromJSDate(new Date()) < date_estimated ? true : false
    const typeOrder = lastOrder.info.type === "Delivery" ? "Entrega estimada" : "Hora estimada:"
    if (orderActive) {
      return <Message title="Pedido En Proceso" text={`${typeOrder} ${date_estimated.hour}:${date_estimated.minute}`} link="/order" icon="time" />
    }
  }
}


const Main = () => {
  const prevScrollY = useRef(0);
  const [goingUp, setGoingUp] = useState(false);
  const [scrollPosition, setScrollPosition] =
    useRecoilState<number>(scrollMenu);
  const location = useLocation();
  const cartProps = useRecoilValue(cartStatus);

  const { width } = useWindowSize();

  const categoriesFetch = useRecoilValue<categoryType[]>(categoriesFetched);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;
      setScrollPosition(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  useEffect(() => {
    window.scrollTo(0, scrollPosition);
    logEvent(analytics, "page_view", { page_title: "Main" })
    //duplicate("benefits","benefits","lsvo79CxKIrK6KLRl3J0","mitad-50")
    //duplicate("benefits","benefits","lsvo79CxKIrK6KLRl3J0","pizza-un-gusto")
    //duplicate("benefits","benefits","lsvo79CxKIrK6KLRl3J0","envio-gratis")
  }, []);

  const clientInfo = useRecoilValue<clientType | undefined>(infoFetched);
  const closed = isClosed(clientInfo!.weekDays);

  return (
    <Layout>
      <LayoutContent>
        <HeaderContainer>
          <Header />
          {lastOrderActive() && WeAreClosed()}
          {closed && <Message title="Estamos cerrados" text="Ver horarios" link="/hours" icon="closed" />}
          {width >= 1024 && <Contact noNav />}
          {width >= 1024 && <Footer/>}
        </HeaderContainer>
        <ContentContainer>

          <Benefits />

          <Recommended/>

          <MainContainer>
            {categoriesFetch.map((item) => {
              return <Category key={item.slug} category={item} />;
            })}
          </MainContainer>
        </ContentContainer>
        {width < 1024 && <Footer/>}
      </LayoutContent>
      <AnimatePresence>
        <Switch location={location} key={location.pathname.split('/')[1]}>
          <Route path="/product/:id" >
            <PopUp>
              <Details />
            </PopUp>
          </Route>
          <Route path="/cart">
            <PopUp>
              <Bag />
            </PopUp>
          </Route>
          <Route path="/checkout">
            <PopUp>
              <Checkout />
            </PopUp>
          </Route>
          <Route path="/hours">
            <PopUp>
              <Hours />
            </PopUp>
          </Route>
          <Route path="/order">
            <PopUp>
              <CurrentOrder />
            </PopUp>
          </Route>
          <Route path="/interested">
            <PopUp>
              <Interested />
            </PopUp>
          </Route>
          <Route path={["/info", "/contacto", "/ubicacion"]}>
            <PopUp>
              <Contact />
            </PopUp>
          </Route>
          <Route path={["/zones", "/zonas", "/delivery"]}>
            <PopUp>
              <Zones />
            </PopUp>
          </Route>
        </Switch>
      </AnimatePresence>
      {cartProps.totalItems > 0 && <AnimatePresence>
        <GoBag />
      </AnimatePresence>
      }
    </Layout>
  );
};

export default Main;
